import LoginForm from "./login"
import ReAuthStyles from "./re-auth.module.css"
import React from "react"
import classNames from "classnames"
import { useAuthState } from "../../context/auth"
import { useTranslation } from "react-i18next"

const ReAuth = ({ onSuccess }) => {
    const { t } = useTranslation("shared")

    const { loading } = useAuthState()

    return (
        <>
            <section className={ReAuthStyles.block}>
                <h4>{t("re_auth_headline")}</h4>
                <p>{t("re_auth_paragraph")}</p>
                <LoginForm onSuccess={onSuccess} />
            </section>
            <div className={classNames({ [ReAuthStyles.loading]: loading })}>
                <div className={ReAuthStyles.spinner} />
            </div>
        </>
    )
}

export default ReAuth
